import { ThemeUIStyleObject } from 'theme-ui';
import { CarrotTheme } from '..';

const baseStyles = {
    h1: {
        variant: 'text.heading',
        fontSize: (theme: CarrotTheme) => theme.fontSizes.huge,
        fontWeight: (theme: CarrotTheme) => theme.fontWeights.boldest,
    },
    h2: {
        variant: 'text.heading',
        lineHeight: '140%',
        fontWeight: (theme: CarrotTheme) => theme.fontWeights.bolder,
        fontSize: (theme: CarrotTheme) => theme.fontSizes.large,
    },
    h3: {
        variant: 'text.heading',
        lineHeight: '150%',
        fontFamily: (theme: CarrotTheme) => theme.fonts.gotham,
        fontSize: (theme: CarrotTheme) => theme.fontSizes.medium,
        fontWeight: (theme: CarrotTheme) => theme.fontWeights.semibold,
    },
    h4: {
        variant: 'text.caps',
        fontSize: '13px',
        fontFamily: (theme: CarrotTheme) => theme.fonts.gotham,
        fontWeight: (theme: CarrotTheme) => theme.fontWeights.bold,
    },
    h5: {
        variant: 'text.heading',
        fontFamily: (theme: CarrotTheme) => theme.fonts.gotham,
        fontSize: (theme: CarrotTheme) => theme.fontSizes.small,
    },
};

function generateVariants() {
    return Object.entries(baseStyles).reduce(
        (accum, [key, value]) => ({
            ...accum,
            [`${key}-dark`]: {
                ...value,
                color: (theme: CarrotTheme) => theme.colors.black,
            },
            [`${key}-accent`]: {
                ...value,
                color: (theme: CarrotTheme) => theme.colors.white,
            },
            [`${key}-primary`]: {
                ...value,
                color: (theme: CarrotTheme) => theme.colors.black,
            },
            [`${key}-secondary`]: {
                ...value,
                color: (theme: CarrotTheme) => theme.colors.white,
            },
        }),
        {}
    );
}
const heading: Record<string, ThemeUIStyleObject> = {
    ...baseStyles,
    ...generateVariants(),
};
export default heading;
